import { ChangeDetectionStrategy, Component, Inject, OnDestroy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDivider } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Store } from '@ngrx/store';
import { WorkspaceDocVersion } from '@workspaces/models/versions';
import { WorkspaceVersionService } from '@workspaces/services/version.service';
import { WorkspaceVersionFetch } from '@workspaces/store/workspace-version.feature';
import { Subscription } from 'rxjs';
import { AppState } from 'src/app/state/app.state';
import { MatIcon } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatChipListbox, MatChip } from '@angular/material/chips';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-version-restore-dialog',
  templateUrl: './version-restore-dialog.component.html',
  styleUrls: ['./version-restore-dialog.component.scss', '../../global-workspace-styles.scss'],
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    CommonModule,
    MatFormFieldModule,
    MatDivider,
    MatIcon,
    MatChipListbox,
    MatChip,
    MatProgressSpinner
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VersionRestoreDialogComponent implements OnDestroy {
  public isSaving = false;
  private readonly sub = new Subscription();
  constructor(
    public readonly dialogRef: MatDialogRef<VersionRestoreDialogComponent>,
    private readonly versionService: WorkspaceVersionService,
    private readonly store: Store<AppState>,
    private readonly snackbar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA)
    public readonly data: {
      workspaceId: string;
      version: WorkspaceDocVersion;
    }
  ) {}

  onCancel(): void {
    this.dialogRef.close();
  }

  save() {
    this.isSaving = true;
    this.sub.add(
      this.versionService
        .restoreVersion(this.data.workspaceId, this.data.version.version_id)
        .subscribe(() => {
          this.store.dispatch(WorkspaceVersionFetch({ workspaceId: this.data.workspaceId }));
          this.dialogRef.close();
          this.snackbar.open('Version was restored.', 'Dismiss', {
            duration: 5000,
            panelClass: ['success-snackbar']
          });
        })
        .add(() => {
          this.isSaving = false;
        })
    );
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
